import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { CartProvider } from "@/lib/cart";
import { useLenis } from "@/lib/useLenis";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Contact from "@/pages/Contact";
import Manifesto from "@/pages/Manifesto";
import Compare from "@/pages/Compare";
import OrderLookup from "@/pages/OrderLookup";
import Admin from "@/pages/Admin";
import Hardening from "@/pages/Hardening";
import PreviewIndex from "@/pages/preview/PreviewIndex";
import HeroEditorial from "@/pages/preview/HeroEditorial";
import HeroTerminal from "@/pages/preview/HeroTerminal";
import HeroVault from "@/pages/preview/HeroVault";
import ProductBento from "@/pages/preview/ProductBento";
import ProductStory from "@/pages/preview/ProductStory";
import ShopGallery from "@/pages/preview/ShopGallery";
import ShopEditorial from "@/pages/preview/ShopEditorial";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  useLenis();
  return (
    <div className="grain min-h-screen">
      <Nav />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:slug" element={<Product />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/orders" element={<OrderLookup />} />
          <Route path="/hardening" element={<Hardening />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/preview" element={<PreviewIndex />} />
          <Route path="/preview/hero-editorial" element={<HeroEditorial />} />
          <Route path="/preview/hero-terminal" element={<HeroTerminal />} />
          <Route path="/preview/hero-vault" element={<HeroVault />} />
          <Route path="/preview/product-bento" element={<ProductBento />} />
          <Route path="/preview/product-story" element={<ProductStory />} />
          <Route path="/preview/shop-gallery" element={<ShopGallery />} />
          <Route path="/preview/shop-editorial" element={<ShopEditorial />} />
        </Routes>
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #1A1A1A",
            color: "#EAEAEA",
            fontFamily: "JetBrains Mono, monospace",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </CartProvider>
  );
}
